var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-popover',{attrs:{"trigger":"hover","placement":_vm.placement,"width":_vm.width}},[_vm._t("default"),_vm._t("reference",function(){return [_c('svg-icon',{staticStyle:{"color":"#409eff"},style:({
                fontSize: _vm.fontSize
            }),attrs:{"slot":"reference","icon-class":"question-circle"},slot:"reference"})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }